<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <div class="main-find ">
       
          <el-radio v-model="radio" label="YES" @change="transform_click">{{ $t("logs.url_a6_xie") }}</el-radio>
         <el-radio v-model="radio" label="NO" @change="transform_click">{{ $t("logs.url_a7_xie") }}</el-radio>
        
       
        
         
       
       

      </div>
        <el-tabs @tab-click="dianji">
          
            <!-- 转化列表-->
            <el-tab-pane label="" v-if="this.radio=='NO'">
                <span slot="label"> {{ $t("logs.url_a4_xie") }}</span>
                <div class="main  maina-a">
                    <p>
                        
                        <el-button @click="tan_filter()">{{ $t("logs.Conditional7") }}</el-button>
                        <el-alert :title="this.show_hint3" type="warning" show-icon :closable="false"></el-alert>
                    </p>

                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100"> </el-table-column>
                            <el-table-column prop="EMAIL" :label="$t('logs.smartLearn8')"> </el-table-column>
                            <el-table-column prop="SHOW_TYPE" :label="$t('logs.smtpIp6')"> </el-table-column>
                            <el-table-column prop="SHOW_ACTION" :label="$t('logs.Policy_list13')"> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="del_ip(scope.$index, scope.row)" type="text" size="small">{{ $t("table1.delete") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu">
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.ctrip4") }}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="emailorip" :placeholder="this.show_hint_holder"></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.smtpIp6") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                           
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_ip()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <div class="pop-up" v-show="tanchu_edit">
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Email:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.smtpIp6") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_edit_ip()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_edit_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
            <!-- 非转化列表-->

         <el-tab-pane label="" v-if="this.radio=='YES'">
                <span slot="label"> {{ $t("logs.url_a5_xie") }}</span>
                <div class="main  maina-a">
                    <p>
                       
                        <el-button @click="tan_filter()">{{ $t("logs.Conditional7") }}</el-button>
                        <el-alert :title="this.show_hint4" type="warning" show-icon :closable="false"></el-alert>
                    </p>

                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100"> </el-table-column>
                            <el-table-column prop="EMAIL" :label="$t('logs.smartLearn8')"> </el-table-column>
                            <el-table-column prop="SHOW_TYPE" :label="$t('logs.smtpIp6')"> </el-table-column>
                            <el-table-column prop="SHOW_ACTION" :label="$t('logs.Policy_list13')"> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="del_ip(scope.$index, scope.row)" type="text" size="small">{{ $t("table1.delete") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu">
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.ctrip4") }}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="emailorip" :placeholder="this.show_hint_holder"></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.smtpIp6") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                           
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_ip()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <div class="pop-up" v-show="tanchu_edit">
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Email:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.smtpIp6") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_edit_ip()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_edit_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            show_hint_holder:'',
            loading:false,
            urlorip: '',
            emailorip: '',
            url_isolate_on: '',
            url_isolate_add_url: '',
            action: 1,
            action_arr: [],
            show_hint1: '',
            show_hint2: '',
            show_hint3: '',
            show_hint4: '',
            show_hint5: '',
            tanchu_edit: false,
            defaut_pol_arr: [],
            defaut_pol: '',
            type: 0,
            type_arr: [],
            ipaddr: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            email: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList1: [],
            fileList2: [],
            radio: '',
            data_loadok1: '',
            tab_num:'2',
        };
    },
    mounted() {
       
        this.getFileList2()
       

    },
    methods: {
        transform_click(value){
            console.log(value)
            this.save_defaut()
        },
         dianji(a) {
      console.log(a.index)
      if(a.index==0){
this.tab_num=2
      }else if(a.index==1){
      this.tab_num=1

      }

      this.getFileList2();
    },
        
      
        del_ip(index, row) {
            // console.log(index, row)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    // console.log(sid);
                    let str = this.$qs.stringify({
                        __mode: "del_url_isolate_person",
                        sid: sid,
                        action:this.tab_num,
                        emailorip: row.EMAIL

                    });
                    this.$axios
                        .post("/api/adm/cgi/aspam.cgi", str)
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.getFileList2()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
       
        save_ip() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: "save_url_isolate_person",
                sid: sid,

                type: this.type,
                action: this.tab_num,
                // newadd: 1,
                emailorip: this.emailorip,

            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false

                        this.getFileList2()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        edit_ip(index, row) {
            console.log(index, row)
            // this.email = row.EMAIL
            // this.type = row.VALUE

            this.tanchu_edit = true

        },
        tan_url() {
            this.tanchu = true
            this.urlorip = ''

        },
        off_edit_ip() {
            this.tanchu_edit = false
        },
        tan_filter() {
            this.tanchu = true
            this.emailorip = ''
        },
        off_ip() {
            this.tanchu = false

        },
        save_defaut() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "save_url_isolatechk_dft_pol",
                        sid: sid,
                        defaut_pol: this.radio
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.getFileList2()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        
        
        // 过滤单元加载
        getFileList2() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_url_isolate_person",
                        sid: sid,
                        action:this.tab_num
                    },
                })
                .then((res) => {
                    console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;

                        this.fileList1 = res.data.ret.datalist

                        this.show_hint4 = res.data.ret.LOAD_HINT4
                        this.show_hint3 = res.data.ret.LOAD_HINT3
                        this.defaut_pol_arr = res.data.ret.q_defaut_pol
                        this.type_arr = res.data.ret.q_type
                        this.action_arr = res.data.ret.q_action
                        this.radio = res.data.ret.DEFAULT_POL
                        this.show_hint_holder=res.data.ret.LOAD_HINT_HOLDER

                    }
                })
               
        },
      
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
    },
};
</script>

<style lang="less" scoped>
// 1
.main {
    display: flex;
    align-items: center;
    border: 2px solid #D2D7E6;

    // background: #f1f1f1;
    margin: 10px;

    text-align: left;
    //   margin-top: 20px;
}

.main p {
    height: 44px;
    width: 100%;
    display: flex;
    padding-left: 10px;
    font-size: 12px;

    align-items: center;
}

.main_text {
    margin-right: 6px;

    color: #0E2C5E;
}

.main .el-input {
    margin-right: 6px
}

.main .el-select {
    margin-right: 6px
}

.main {
    padding: 0;
}

/deep/ .el-input__icon {
    height: 24px;
    line-height: 24px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";


.el-radio{
    color: #0e2c5e;

}
.main-find {
  // width: 100%;
  height: 50px;
  padding-left: 14px;
  // padding-bottom: 5px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: left;

  border-bottom: 2px solid #d2d7e6;
  // background: #FFFFFF;

  span {
    margin-right: 8px;

    // width: 126px;
    // display: inline-block;
    color: #0e2c5e;
  }

  .el-input {
    margin-right: 8px;
    width: 20%;
    line-height: 32px;
    height: 32px;
    // padding: 5px 10px 5px 0;
  }

  // input 框高度
  /deep/ .el-input__inner {
    height: 32px;
    padding: 0 6px;
  }

  /deep/ .el-input--suffix {
    // width: 150px;
    margin-right: 10px;
  }

  /deep/ .el-button {
    margin-right: 10px;
    // margin-left: 30px;
  }
}
/deep/  .el-tabs__nav {
    padding-left: 15px;
}
</style>
